/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import actions from 'redux/actions';
import { Field, reduxForm } from 'redux-form';
import { Prompt } from 'react-router-dom';

import validation from './validation';

import Button from 'components/Button';
import InputText from 'components/FormInputText';
import styles from './styles.module.scss';

import type { Translate, ReduxFormProps } from 'types';

const mapStateToProps = state => {
  return {};
};

type FormParams = {
  name: string,
  description: string,
};

type Props = ReduxFormProps & {
  title?: string,
  save: (params: FormParams) => mixed,
  cancel?: () => mixed,
  // RR
  router: any,
  t: Translate,
};

class ProductionForm extends React.Component<Props> {
  _handleResetClick = () => {
    this.props.reset('worklistBasic');
    this.props.cancel && this.props.cancel();
  };

  render() {
    const { handleSubmit, valid, dirty, pristine, title, isLoading, t } = this.props;
    return (
      <form className={styles.form} onSubmit={handleSubmit}>
        <Prompt when={dirty} message={location => t('CONFIRM_EXIT_DIRTY_FORM')} />
        {title && <legend className={styles.formTitle}>{title || '...'}</legend>}
        <Field component={InputText} name={'name'} label={t('NAME')} disabled={isLoading} />
        <Field
          component={InputText}
          name={'description'}
          label={t('DESCRIPTION')}
          disabled={isLoading}
        />
        <div className={styles.formButtons}>
          <div>
            <Button
              text={t('RESET')}
              onClick={this._handleResetClick}
              disabled={isLoading || pristine}
              loading={isLoading}
            />
          </div>
          <div>
            <Button
              text={t('SAVE')}
              onClick={handleSubmit(this.props.save)}
              disabled={isLoading || !valid || pristine}
              loading={isLoading}
              appearance={'primary'}
            />
          </div>
        </div>
      </form>
    );
  }
}

export default withTranslation()(
  connect(
    mapStateToProps,
    actions
  )(
    reduxForm({
      form: 'worklistBasic',
      validate: validation,
      enableReinitialize: true,
      //$FlowFixMe
      // destroyOnUnmount: !(keys.IS_ENV_DEVELOPMENT && module.hot),
      destroyOnUnmount: true,
    })(ProductionForm)
  )
);
